import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { ArtifactNotesViewModel } from './artifact-notes.viewmodel';
import { applyText, cancelText } from '../../../../../../constants/common-labels.constants';

interface IProps {
    vm: ArtifactNotesViewModel;
}

export const ArtifactNotesPresentation = observer((props: IProps): JSX.Element => {
    const { vm } = props;
    const { note, permissionToEdit } = vm;

    return (
        <div className='artifact-notes-form-in-popover' data-test-id='artifact-notes-popup'>
            <div className='artifact-notes-form-in-popover__content'>
                <FormField
                    className='oe-form-field'
                    label={<FormattedMessage
                        id='oe.artifact.Notes'
                        description='Label text'
                        defaultMessage='Notes'
                    />}
                >
                    <textarea
                        className='artifact-notes-textarea'
                        disabled={!permissionToEdit}
                        value={note}
                        onChange={permissionToEdit && action(e => vm.setNotes(e.target.value))}
                    />
                </FormField>
                <span className='oe-form-field__error'>{vm.getNotesError()}</span>
            </div>
            {
                <div className='oe-popup-layout__footer'>
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultButton
                            text={applyText()}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => vm.updateNotes()}
                            disabled={!permissionToEdit || !!vm.getNotesError()}
                        />
                        <DefaultButton
                            modifier='cancel'
                            text={cancelText()}
                            onClick={() => vm.closeArtifactNotesPopup()}
                        />
                    </div>
                </div>
            }
        </div>
    );
});